var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.2847,
    r: 10,
    fill: "#A0DC8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1209 6.32228C15.301 6.11292 15.6167 6.08918 15.826 6.26926C16.0121 6.42932 16.0516 6.69654 15.9316 6.90098L15.8791 6.97437L9.62357 14.2471C9.45326 14.4451 9.16452 14.4753 8.9587 14.3315L8.88579 14.2694L5.14129 10.4131C4.94892 10.215 4.95357 9.89844 5.15168 9.70607C5.32778 9.53507 5.59746 9.51975 5.79032 9.65759L5.85871 9.71646L9.222 13.1797L15.1209 6.32228Z",
    fill: "#146E37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.7fb1636d7e83fff9a3910917262aaf3e.svg";
export { ForwardRef as ReactComponent };